<style scoped>
  svg {
    margin-right: 5%;
  }

  v-item--active {
    color: black;
  }

  .form-info {
    font-size: small;
    font-family: Arial;
  }
  .imgPreview {
    max-width: 150px;
    max-height: 150px;
  }
</style>
<template class="ma-0 pa-0">
  <v-container fluid class="ma-0 pa-0">
    <v-card class="ma-0 ma-md-2 pa-0 pa-md-2" elevation="10">
      <v-card-title class="form-info">
        <span>{{ formTitle }}</span>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="showPreview">
          <v-btn color="blue darken-1" text :disabled="isFileInvalid"
                 @click="submitFileVuetify">Sauver cette photo</v-btn>
        </template>
      </v-card-actions>
      <v-card-text>
        <v-container fluid>
          <v-row class="text-center ma-0 pa-0">
            <v-col cols="12" lg="6" class="ma-0 pa-0">
              <v-file-input dense
                ref="gofile" @change="handleFileUploadVuetify"
                v-model="chosenFile"
                required
                :rules= "[
                (val) => !val || val.size < maxUploadSizeInBytes
                || `Erreur : Photo trop grosse !
                (max ${Math.round(maxUploadSizeInBytes/1024/1024)} MB)`,
                ]"
                accept="image/png, image/jpeg"
                placeholder="Cliquez pour sélectionner une photo"
                :prepend-icon="mdiCamera"
                label="Ajoutez une photo..."
                show-size
                :error-messages="errorMessages"
                v-bind:clearable="true"
              />
            </v-col>
            <v-col cols="12" lg="6" class="ma-0 pa-0 align-end" >
              <v-img class="imgPreview" aspect-ratio="1.5"
                     :src="imagePreview" v-show="showPreview"/>
            </v-col>
            <!--<v-col cols="12" xl="6" class="ma-0 pa-0">
              <v-text-field
                ref="titre" dense outlined
                v-model="documentInfo.title"
                required
                :counter="maxTextLength"
                :rules="[
                  () => !!documentInfo.title || 'Ce champ est obligatoire',
                  () => documentInfo.title.length <= maxTextLength || '255 caractères max'
                ]"
                :error-messages="errorMessages"
                v-bind:clearable="true"
                label="Titre"
              />
            </v-col>-->
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mdiCamera } from '@mdi/js';
import axios from 'axios';
import { isNullOrUndefined } from 'cgil-html-utils';
import {
  APP, DEV, getLog, DEFAULT_BASE_SERVER_URL,
} from '../config';
import {
  getUserId, getUserIsAdmin,
  getUserIsValidator, getLocalJwtTokenAuth,
} from './Login';


const MODULE_NAME = 'DocumentUploadForm';
const log = getLog(MODULE_NAME, 4, 2);
const getErrorMessage = (method, msg, err) => {
  let errMessage = msg;
  let lastErrorMsg = '';
  log.e(errMessage);
  if (err.response) {
    const errResponse = err.response;
    log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
    lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
    errMessage += `${lastErrorMsg} <br> Message serveur : ${errResponse.data.message}`;
    // this.lastError = err.response;
  } else if (err.request) {
    log.e(' -- The request was made, but no response was received from the server', err.request);
    lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
    errMessage += `${lastErrorMsg} <br> Message serveur : ${err.request}`;
    // this.lastError = err.request;
  } else {
    log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
    lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
    errMessage += `${lastErrorMsg} <br> Message serveur : ${err.message}`;
    // this.lastError = err.message;
  }
  return errMessage;
};

export default {
  name: 'DegradationForm',
  components: {},
  props: {
    currentObject: {
      type: Object,
      default: null,
    },
    maxUploadSizeInBytes: {
      type: Number,
      default: 8388608, // 8 MB --> must be smaller then server limit !
    },
  },
  data: () => ({
    appName: APP,
    isInDev: DEV,
    subject: 'Photo',
    isUserAdmin: false,
    isUserValidator: false,
    idUser: null,
    showPreview: false,
    imagePreview: '',
    chosenFile: null,
    isFileInvalid: true,
    defaultDocument: {
      id: 0,
      title: '',
      idDegradation: null,
      comment: null,
    },
    documentInfo: {
      id: 0,
      title: '',
      idDegradation: null,
      comment: null,
    },
    maxTextLength: 255,
    dialogFormObjetHasErrors: false,
    errorMessages: '',
    mdiCamera,
  }),
  created() {
    log.t(`# ${MODULE_NAME} created()`);
  },
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
    this.isUserAdmin = getUserIsAdmin();
    this.isUserValidator = getUserIsValidator();
    this.idUser = getUserId();
    if (!isNullOrUndefined(this.currentObject.properties)) {
      this.documentInfo.title = this.currentObject.properties.title;
      this.documentInfo.idDegradation = this.currentObject.properties.id;
    }
  }, // end of mounted
  filters: {
  },
  computed: {
    formTitle() {
      return `Ajoutez une ${this.subject} à la dégradation id:${this.documentInfo.idDegradation}`;
    },
  },

  watch: {
    currentObject(newVal, oldVal) {
      log.t(`in watch currentObject(${newVal}, ${oldVal})`, newVal, oldVal);
      // this.editedItem = JSON.parse(JSON.stringify(newVal));
      // pas de copie a ce stade pour qu'un update de position fonctionne
      this.editedItem = newVal;
      if (!isNullOrUndefined(this.editedItem.properties)) {
        this.documentInfo.title = this.editedItem.properties.title;
        this.documentInfo.idDegradation = this.editedItem.properties.id;
      }
      log.w(`-id:${this.documentInfo.id}`);
    },
  },

  methods: {
    initialize() {
      this.chosenFile = null;
      this.showPreview = false;
      this.isFileInvalid = true;
      this.imagePreview = '';
      this.documentInfo = JSON.parse(JSON.stringify(this.defaultDocument));
    },
    handleFileUploadVuetify(files) {
      log.t('handleFileUploadVuetify adding docs files:', files);
      if (!isNullOrUndefined(this.chosenFile)) {
        const extension = this.chosenFile.name.substring(
          this.chosenFile.name.lastIndexOf('.') + 1,
        ).toLowerCase();
        if ((extension === 'jpg') || (extension === 'jpeg') || (extension === 'png')) {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.showPreview = true;
            this.imagePreview = reader.result;
          }, false);
          log.l('about to readAsDataURL for chosenFile', this.chosenFile);
          reader.readAsDataURL(this.chosenFile);
          this.isFileInvalid = false;
        } else {
          const errMessage = `this extension is invalid : ${extension}`;
          log.w(errMessage);
          const tempItem = JSON.parse(JSON.stringify(this.currentObject));
          this.initialize();
          this.$emit('documentExtensionInvalidError', errMessage, tempItem);
          // this.isFileInvalid = true;
        }
      }
    },
    submitFileVuetify() {
      const method = 'submitFileVuetify';
      const formData = new FormData();
      //  Add the form data we need to submit
      formData.append('file', this.chosenFile);
      formData.append('title', this.documentInfo.title);
      formData.append('id_degradation', this.documentInfo.idDegradation);
      axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
      axios.post(`${DEFAULT_BASE_SERVER_URL}/api/document/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((resp) => {
        log.t(`## IN ${method} axios get SUCCESS resp.data :`, resp.data);
        const tempItem = JSON.parse(JSON.stringify(this.currentObject));
        this.initialize();
        this.$emit('documentUploadSave', tempItem);
        // if (functionExist(callbackLoaded)) callbackLoaded(resp.data, 'SUCCESS');
      })
        .catch((err) => {
          log.w('problem while uploading document', err);
          const errMessage = getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.post`, err);
          const tempItem = JSON.parse(JSON.stringify(this.currentObject));
          this.initialize();
          this.$emit('documentUploadSaveError', errMessage, tempItem);
          log.e(errMessage);
        });
    },
  }, // end of methods
};
</script>
